module.exports = __webpack_public_path__ + "fromBrideToFather-we-w.9fe623ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromBrideToFather-we-w.jpg
// module id = 0Gun
// module chunks = 0